import { render, staticRenderFns } from "./MaterialRouteInfo.vue?vue&type=template&id=2a1087aa&scoped=true&"
import script from "./MaterialRouteInfo.vue?vue&type=script&lang=js&"
export * from "./MaterialRouteInfo.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRouteInfo.vue?vue&type=style&index=0&id=2a1087aa&prod&scoped=true&lang=css&"
import style1 from "./MaterialRouteInfo.vue?vue&type=style&index=1&id=2a1087aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1087aa",
  null
  
)

export default component.exports